import { AfterViewInit, Component, DebugElement, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { Subscription, firstValueFrom, map } from 'rxjs';
import { NavbarService } from 'src/app/core/services/behavior/navbar.service';
import { StorageService } from 'src/app/core/services/behavior/storage.service';
import { AuthenticationService } from 'src/app/core/services/http/authentication.service';
import { LocalizarPedidoInputService } from './../../../core/services/behavior/localizar-pedido-input.service';

import { PedidoService } from 'src/app/core/services/http/pedido.service';
import { AceitarRejeitarPedidoDeliveryDialogComponent } from 'src/app/shared/components/aceitar-rejeitar-pedido-delivery-dialog/aceitar-rejeitar-pedido-delivery-dialog.component';
import { LocalizarClientesComponent, LocalizarClientesDataClose } from 'src/app/shared/components/localizar-clientes/localizar-clientes.component';
import { PagarContaComponent } from 'src/app/shared/components/pagar-conta/pagar-conta.component';
import { SelecionarProdutoComponent, SelecionarProdutoDataClose } from 'src/app/shared/components/selecionar-produto/selecionar-produto.component';
import { ModalRoleEnum } from 'src/app/shared/enums/modal-role.enum';
import { StatusPedidoEnum } from 'src/app/shared/enums/status-pedido.enum';
import { TipoAtendimentoEnum } from 'src/app/shared/enums/tipo-atendimento.enum';
import { ModalResult } from 'src/app/shared/interfaces/modal-result.interface';
import { PedidoDeliveryResponse, PedidoModel } from 'src/app/shared/models/pedido.model';
import { EnderecoPessoa, PessoaModel } from 'src/app/shared/models/pessoa.model';
import { UsuarioModel } from 'src/app/shared/models/usuario.model';
import { DialogStateUtil } from 'src/app/shared/utils/dialog-state.util';
import { HelpersUtil } from 'src/app/shared/utils/helpers.util';
import { environment } from 'src/environments/environment';
import { EscolherFormaPgtoDialogComponent, EscolherFormaPgtoDialogDataClose } from 'src/app/shared/components/escolher-forma-pgto-dialog/escolher-forma-pgto-dialog.component';
import { PessoaService } from 'src/app/core/services/http/pessoa.service';
import { SelecionarEnderecoDeliveryDataClose, SelecionarEnderecoDeliveryDialogComponent } from 'src/app/shared/components/selecionar-endereco-delivery-dialog/selecionar-endereco-delivery-dialog.component';
import { ModaisIdEnum, ModaisService } from 'src/app/core/services/behavior/modais.service';
import { FormaPgtoRequestV1 } from 'src/app/shared/models/forma-pgto.model';
import { DeviceService } from 'src/app/core/services/behavior/device.service';
import { DatetimeService } from 'src/app/core/services/http/datetime.service';
import { ToastService } from 'src/app/core/services/behavior/toast.service';

@Component({
    selector: 'app-delivery',
    templateUrl: './delivery.component.html',
    styleUrls: ['./delivery.component.scss']
})
export class DeliveryComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('searchInpt', { static: false }) private searchInpt: ElementRef<HTMLInputElement>;

    private _podeCancelarPedido = false;
    private milisegundosAtualizacao: number;
    private pedidos: PedidoDeliveryResponse[] = [];
    private subs$: Subscription[] = [];

    private interval: any;

    public isLoading = true;
    public isFirstLoading = true;
    public pedidosFiltrados: PedidoDeliveryResponse[] = [];
    public usuarioLogado = this.authService.user;
    public enviandoReq = false;

    constructor(
        private _alertCtrl: AlertController,
        private modalCtrl: ModalController,

        private authService: AuthenticationService,
        private pedidoService: PedidoService,
        private _localizarPedidoInputService: LocalizarPedidoInputService,
        private _navbarService: NavbarService,
        private _pessoaService: PessoaService,
        private _storageService: StorageService,
        private _modaisService: ModaisService,
        private deviceService: DeviceService,
        private datetimeService: DatetimeService,
        private _toastService: ToastService
    ) { }

    public async abrirModalAceitarRejeitarPedidoDelivery(numeroComanda: number) {
        const modal = await this.modalCtrl.create({
            component: AceitarRejeitarPedidoDeliveryDialogComponent,
            componentProps: {
                numeroComanda: numeroComanda
            },
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult: ModalResult = await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();

        if (modalResult.role === ModalRoleEnum.CONFIRM) {
            this.load();
        }
    }

    public calcularTempo(tempo) {
        return HelpersUtil.formatarTempoDecorrido(tempo);
    }

    public async cancelarPedido(numeroComanda: number) {
        if (this.enviandoReq) {
            this._toastService.show('Já existe uma requisição em andamento. Por favor, aguarde.', 'warning');
            return;
        }

        this.enviandoReq = true;

        if (!this._podeCancelarPedido) {
            await this.showErrorMessage('Você não tem permissão para cancelar o pedido. Por favor, selecione um usuário que tenha autorização.');

            const confirmarUsuarioDialogDataClose = await this._modaisService.modalConfirmarUsuarioDialogAsync();

            if (confirmarUsuarioDialogDataClose.role === ModalRoleEnum.CANCEL)
                return;

            if (!confirmarUsuarioDialogDataClose.data.usuario.pdV_CancelarPedido)
                return await this.showErrorMessage('O usuário selecionado também não possui a permissão desejada.');
        }

        this.pedidoService.cancelarPedido(numeroComanda).subscribe(res => {
            if (res.success) {
                this.load();
            }
        })
    }

    public enviarParaCozinha(pedido: PedidoDeliveryResponse) {
        if (this.enviandoReq) {
            this._toastService.show('Já existe uma requisição em andamento. Por favor, aguarde.', 'warning');
            return;
        }

        this.enviandoReq = true;

        this.pedidoService.updateCodigoStatusCab(pedido.numeroComanda, StatusPedidoEnum.EmPreparo)
            .subscribe(() => {
                this.load();
                // this.enviandoReq = false;
            });
    }

    public enviarParaEntrega(pedido: PedidoDeliveryResponse) {
        if (this.enviandoReq) {
            this._toastService.show('Já existe uma requisição em andamento. Por favor, aguarde.', 'warning');
            return;
        }

        this.enviandoReq = true;

        this.pedidoService.updateCodigoStatusCab(pedido.numeroComanda, StatusPedidoEnum.SaiuEntrega)
            .subscribe(() => {
                this.load();
                // this.enviandoReq = false;
            });
    }

    public filtrarPedidos(value: string) {
        if (!value) {
            this.pedidosFiltrados = this.pedidos;
            return;
        }

        this.pedidosFiltrados = HelpersUtil.filterAllFields(this.pedidos, value);
    }

    public imprimir(pedidoBalcao: PedidoDeliveryResponse): void {
        const sub$ = this.pedidoService.imprimirPedido(pedidoBalcao.numeroComanda).subscribe();

        this.subs$.push(sub$);
    }

    public async iniciarPedido(pedidoRecebido: PedidoModel = null) {
        if (!pedidoRecebido) pedidoRecebido = new PedidoModel({ cliente: null });

        let pedido = pedidoRecebido;

        const modalResultSelecionarProduto = await this._modalSelecionarProdutosAsync(pedido);

        if (modalResultSelecionarProduto.role === ModalRoleEnum.CANCEL)
            return;

        if (modalResultSelecionarProduto.role === ModalRoleEnum.CONFIRM && !pedido.cliente) {
            pedido = new PedidoModel({
                numeroComanda: modalResultSelecionarProduto.data.pedido.numeroComanda,
                dets: modalResultSelecionarProduto.data.pedido.dets,
                codigoEmpresa: pedidoRecebido.codigoEmpresa,
            });

            const modalResultSelecionarCliente = await this._modalSelecionarClientesAsync(pedido);

            if (modalResultSelecionarCliente.role === ModalRoleEnum.CANCEL) {
                pedido.cliente = null;

                return await this.iniciarPedido(pedido);
            }

            if (modalResultSelecionarCliente.role === ModalRoleEnum.CONFIRM) {
                pedido.cliente = modalResultSelecionarCliente.data.cliente;

                try {
                    const enderecosCliente = await this._obterEnderecosClienteAsync(pedido.cliente.codigo);

                    if (enderecosCliente.length > 1) {
                        const modalResultSelecionarEndereco = await this._modalSelecionarEnderecoAsync(enderecosCliente);

                        if (modalResultSelecionarEndereco.role === ModalRoleEnum.CANCEL) {
                            pedido.cliente = null;

                            return await this.iniciarPedido(pedido);
                        }

                        if (modalResultSelecionarEndereco.role === ModalRoleEnum.CONFIRM) {
                            pedido.codigoEndereco = modalResultSelecionarEndereco.data.endereco.codigo;
                        }
                    }
                } catch (error) {
                    return HelpersUtil.executeAfterDelay(async () => this._lidarComErroAoObterEnderecosCliente(pedido), 3000);
                }

                const modalResultEscolherFormaPgto = await this._modalEscolherFormaPgtoAsync(pedido);

                if (modalResultEscolherFormaPgto.role === ModalRoleEnum.CANCEL)
                    return await this.iniciarPedido(pedido);

                if (modalResultEscolherFormaPgto.role === ModalRoleEnum.CONFIRM) {
                    this._lidarComEscolhaFormaPgto(modalResultEscolherFormaPgto.data, pedido);

                    await this._enviarPedidoAsync(pedido);

                    return;
                }
            }
        }

        const modalResultEscolherFormaPgto = await this._modalEscolherFormaPgtoAsync(pedido);

        if (modalResultEscolherFormaPgto.role === ModalRoleEnum.CANCEL)
            return await this.iniciarPedido(pedido);

        if (modalResultEscolherFormaPgto.role === ModalRoleEnum.CONFIRM) {
            this._lidarComEscolhaFormaPgto(modalResultEscolherFormaPgto.data, pedido);

            await this._enviarPedidoAsync(pedido);
        }
    }

    private _lidarComEscolhaFormaPgto(data: EscolherFormaPgtoDialogDataClose, pedido: PedidoModel) {
        switch (data.formaPgto) {
            case 'Cartao':
                pedido.bandeiraCartao = data.bandeiraCartao;
                break;

            case 'Dinheiro':
                pedido.troco = data.troco;
                break;
        }

        pedido.formaPgtoDelivery = data.formaPgto;
        pedido.obsPgto = data.observacao;
    }

    public async modalPagarConta(pedidoDelivery: PedidoDeliveryResponse): Promise<void> {
        const pedido = new PedidoModel({
            numeroComanda: pedidoDelivery.numeroComanda,
            cliente: new PessoaModel({
                nome: pedidoDelivery.nomeCliente
            })
        });

        const modal = await this.modalCtrl.create({
            component: PagarContaComponent,
            componentProps: {
                pedido: pedido,
                tipoAtendimento: TipoAtendimentoEnum.DELIVERY
            },
            cssClass: 'full-screen-dialog',
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult: ModalResult<any> = await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();

        if (modalResult.role === ModalRoleEnum.CONFIRM) {
            this.load();
        }
    }

    public async modalSelecionarProdutos(pedidoDelivery: PedidoDeliveryResponse) {
        let pedido = new PedidoModel({
            numeroComanda: pedidoDelivery.numeroComanda
        });

        const modal = await this.modalCtrl.create({
            component: SelecionarProdutoComponent,
            componentProps: {
                pedido: pedido,
                tipoAtendimento: TipoAtendimentoEnum.DELIVERY
            },
            backdropDismiss: false,
            keyboardClose: false,
            cssClass: 'full-screen-dialog'
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult: ModalResult<SelecionarProdutoDataClose> = await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();

        if (modalResult.role === ModalRoleEnum.CONFIRM) {
            pedido = new PedidoModel({
                numeroComanda: modalResult.data.pedido.numeroComanda,
                dets: modalResult.data.pedido.dets,
                cliente: modalResult.data.pedido.cliente,
                codigoEndereco: modalResult.data.pedido.codigoEndereco
            });

            const formaPgto = new FormaPgtoRequestV1();
            pedido.FormaPgtoOldV1 = formaPgto;
            pedido.terminalId = this.deviceService.device.idDispositivo;

            const datahora = await this.datetimeService.obterDataHora();
            pedido.dataHora = datahora;

            const sub$ = this.pedidoService.enviarPedido(pedido, TipoAtendimentoEnum.DELIVERY).subscribe(() => this.load());

            this.subs$.push(sub$);
        }
    }

    public ngAfterViewInit(): void {
        this.searchInpt.nativeElement.addEventListener('focus', () => this._localizarPedidoInputService.estaFocado = true);
        this.searchInpt.nativeElement.addEventListener('blur', () => this._localizarPedidoInputService.estaFocado = false);
    }

    public ngOnDestroy(): void {
        this.subs$.forEach(sub$ => sub$.unsubscribe());
        if (this.interval) clearInterval(this.interval);
    }

    public async ngOnInit() {
        this.load();

        const milisegundosAtualizacaoExiste = await this._storageService.isExist(environment.milisegundosAtualizacaoTelaDeliveryKey);

        if (milisegundosAtualizacaoExiste) {
            this.milisegundosAtualizacao = await this._storageService.get(environment.milisegundosAtualizacaoTelaDeliveryKey) as number;
        } else {
            await this._storageService.set(environment.milisegundosAtualizacaoTelaDeliveryKey, 30000);
            this.milisegundosAtualizacao = 30000;
        }

        this.interval = setInterval(() => {
            if (!DialogStateUtil.isDialogCurrentlyOpen) {
                this.load();
            }
        }, this.milisegundosAtualizacao);

        this._verificarMudancasNumeroComanda();

        const usuarioLogado = await this._storageService.get('user') as UsuarioModel;

        this._podeCancelarPedido = usuarioLogado.pdV_CancelarPedido;
    }

    @HostListener('window:keydown', ['$event'])
    public async onKeydown(event: KeyboardEvent): Promise<void> {
        const existeModalAberto = await this.modalCtrl.getTop();

        if (existeModalAberto) return;

        switch (event.key) {
            case 'F2':
                if (!DialogStateUtil.isDialogCurrentlyOpen) {
                    this.iniciarPedido();
                }

                break;
            case 'F8':
                this.searchInpt.nativeElement.focus();
                break;
        }
    }

    private _acionarFocoNumeroMesaInput() {
        HelpersUtil.executeAfterDelay(() => this._navbarService.focarNumeroMesaInput$.next(true));
    }

    private async _enviarPedidoAsync(pedido: PedidoModel) {
        const formaPgto = new FormaPgtoRequestV1();
        pedido.FormaPgtoOldV1 = formaPgto;
        pedido.terminalId = this.deviceService.device.idDispositivo;

        const datahora = await this.datetimeService.obterDataHora();
        pedido.dataHora = datahora;

        const sub$ = this.pedidoService.enviarPedido(pedido, TipoAtendimentoEnum.DELIVERY)
            .subscribe(async res => {
                if (res.success) {
                    this.load();

                    const modal = await this.modalCtrl.getTop();

                    modal.dismiss();
                }
            });

        this.subs$.push(sub$);
    }

    private async _lidarComErroAoObterEnderecosCliente(pedido: PedidoModel) {
        const existeMensagemErroAberto = this._alertCtrl.getTop();

        if (existeMensagemErroAberto)
            await this._alertCtrl.dismiss();

        await this.iniciarPedido(pedido);
    }

    private async _modalEscolherFormaPgtoAsync(pedido: PedidoModel): Promise<ModalResult<EscolherFormaPgtoDialogDataClose>> {
        const modal = await this.modalCtrl.create({
            component: EscolherFormaPgtoDialogComponent,
            cssClass: 'custom-modal',
            componentProps: {
                pedido: pedido
            },
            backdropDismiss: false
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult = await modal.onWillDismiss() as ModalResult<EscolherFormaPgtoDialogDataClose>;

        DialogStateUtil.dialogIsClosed();

        return modalResult;
    }

    private async _modalSelecionarClientesAsync(pedido: PedidoModel) {
        const modal = await this.modalCtrl.create({
            component: LocalizarClientesComponent,
            cssClass: 'full-screen-dialog',
            backdropDismiss: false,
            keyboardClose: false,
            id: "modalSelecionarCliente"
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult: ModalResult<LocalizarClientesDataClose> = await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();

        return modalResult;
    }

    private async _modalSelecionarEnderecoAsync(enderecos: EnderecoPessoa[]) {
        const modal = await this.modalCtrl.create({
            component: SelecionarEnderecoDeliveryDialogComponent,
            componentProps: {
                enderecos
            },
            cssClass: 'custom-modal-h50',
            backdropDismiss: false,
            id: ModaisIdEnum.SELECIONAR_ENDERECO
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult = await modal.onWillDismiss() as ModalResult<SelecionarEnderecoDeliveryDataClose>;

        DialogStateUtil.dialogIsClosed();

        return modalResult;
    }

    private async _modalSelecionarProdutosAsync(pedido: PedidoModel) {
        const modal = await this.modalCtrl.create({
            component: SelecionarProdutoComponent,
            componentProps: {
                pedido: pedido,
                tipoAtendimento: TipoAtendimentoEnum.DELIVERY
            },
            cssClass: 'full-screen-dialog',
            backdropDismiss: false,
            keyboardClose: false
        });

        await modal.present();

        DialogStateUtil.dialogIsOpen();

        const modalResult: ModalResult<SelecionarProdutoDataClose> = await modal.onWillDismiss();

        DialogStateUtil.dialogIsClosed();

        return modalResult;
    }

    private async _obterEnderecosClienteAsync(codigoCliente: number) {
        const obs$ = this._pessoaService.getAllEnderecos(codigoCliente).pipe(
            map(response => {
                if (response.success) {
                    return response.data;
                } else {
                    throw new Error('Erro ao obter endereços');
                }
            }),
        );

        return await firstValueFrom(obs$);
    }

    private _verificarMudancasNumeroComanda() {
        this._navbarService.numeroComandaDigitado$.subscribe(res => {
            const numeroComanda = (res ?? '').toString();

            if (!numeroComanda) {
                return;
            }

            this.searchInpt.nativeElement.value = numeroComanda;

            this.searchInpt.nativeElement.focus();
            this.filtrarPedidos(numeroComanda);
        })
    }

    private load() {
        let pedidosFiltradosAntigo = this.pedidosFiltrados;
        this.enviandoReq = true;

        const sub$ = this.pedidoService
            .obterPedidosDelivery()
            .subscribe(res => {
                this.pedidos = res.success ? res.data : [];

                this.pedidos.forEach((p) => {
                    if (p.enderecoCliente.includes('RETIRADA NA LOJA') && p.statusPedido === 'SAIU P/ ENTREGA') {
                        p.statusPedido = 'PRONTO P/ RETIRADA';
                    }
                });

                this.pedidosFiltrados = this.pedidos;
                this.isLoading = false;

                if (!this.isFirstLoading) {
                    const existePedidoAguardando = res.data.some((pedido) => pedido.statusPedido === 'AGUARDANDO');

                    if (existePedidoAguardando) {
                        this.tocarNotificacao();
                    }
                }

                this.isFirstLoading = false;

                const filtroDoInput = this.searchInpt.nativeElement.value;

                if (this._localizarPedidoInputService.existeValorParaSetar || filtroDoInput) {
                    const filtro = filtroDoInput || this._localizarPedidoInputService.novoValorParaSetar;

                    this.searchInpt.nativeElement.value = filtro;
                    this.searchInpt.nativeElement.focus();

                    this.filtrarPedidos(filtro);
                } else {
                    this._acionarFocoNumeroMesaInput();
                }

                this.enviandoReq = false;
            });

        this.subs$.push(sub$);
    }

    private tocarNotificacao() {
        new Audio('/assets/audio/positive-notification.wav').play();
    }

    private async showErrorMessage(msg: string) {
        const alert = await this._alertCtrl.create({
            header: 'ATENÇÃO',
            message: msg,
            buttons: ['OK']
        });

        await alert.present();

        await alert.onWillDismiss();
    }
}
